<div class="mensaje-importante-container" *ngIf="mostrarGlobalmente">
    <div class="imagen-container">
        <img alt="!" src="../assets/important.png" width="42" height="45" />
    </div>
    <div class="texto-container">
        <p>
            <strong>IMPORTANTE:</strong> momentáneamente y debido al contexto económico, hemos
            ajustado el monto máximo de crédito por solicitante a <strong>$30.000.000</strong>.
        </p>
        <p>
            Para más detalles o consultas, podés comunicarte con nosotros a través de los
            medios disponibles en <a href="https://ftyc.gob.ar" style="color: #000; text-decoration: underline">ftyc.gob.ar</a>.
        </p>
    </div>
</div>
